import ActionTypes from "../constants/ActionTypes";

export const storeWindow = windowObj => {
  return {
    type: ActionTypes.STORE_WINDOW,
    windowObj: windowObj
  };
};
